
  var _styles = {
  "rank-poi-item__wrapper": {
    "width": "9.36rem",
    "height": "5.26667rem",
    "position": "relative",
    "flexDirection": "column",
    "justifyContent": "flex-end",
    "alignItems": "flex-start"
  },
  "rank-poi-item__rank-img-wrapper": {
    "position": "absolute",
    "top": 0,
    "left": "0.24rem",
    "zIndex": 1,
    "width": "1.30667rem",
    "height": "1.36rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "rank-poi-item__rank-img": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "1.30667rem",
    "height": "1.36rem"
  },
  "rank-poi-item__rank-img-text": {
    "marginTop": "0.33333rem",
    "maxWidth": "1.30667rem",
    "color": "rgb(96,54,33)",
    "fontFamily": "meituan type",
    "fontWeight": "700",
    "fontSize": "0.48rem",
    "position": "relative",
    "zIndex": 1
  },
  "rank-poi-item__info-wrapper": {
    "position": "absolute",
    "zIndex": 1,
    "left": "0.24rem",
    "bottom": "0.37333rem",
    "flexDirection": "column",
    "justifyContent": "flex-start",
    "alignItems": "flex-start"
  },
  "rank-poi-item__title": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.48rem",
    "maxWidth": "8.8rem"
  },
  "rank-poi-item__review-info-wrapper": {
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "baseline"
  },
  "rank-poi-item__score": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "marginRight": "0.08rem"
  },
  "rank-poi-item__rating": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "marginRight": "0.08rem"
  },
  "rank-poi-item__recommend": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem"
  },
  "rank-poi-item__tags-wrapper": {
    "marginTop": "0.10667rem",
    "height": "0.42667rem",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "rank-poi-item__tag": {
    "height": "0.42667rem",
    "marginRight": "0.16rem",
    "borderRadius": "0.08rem",
    "overflow": "hidden",
    "paddingTop": 1,
    "paddingLeft": "0.10667rem",
    "paddingRight": "0.10667rem",
    "backgroundColor": "rgba(0,0,0,0.6)",
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "rank-poi-item__price-wrapper": {
    "position": "absolute",
    "zIndex": 1,
    "right": "0.24rem",
    "bottom": "0.29333rem",
    "flexDirection": "row",
    "justifyContent": "flex-start",
    "alignItems": "baseline"
  },
  "rank-poi-item__price-prefix": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "marginRight": "0.01333rem"
  },
  "rank-poi-item__price-text": {
    "marginLeft": "0.01333rem",
    "color": "rgb(255,255,255)",
    "fontFamily": "MT New Digital Display",
    "fontWeight": "700",
    "fontSize": "0.56rem"
  },
  "rank-poi-item__slider-item": {
    "width": "9.36rem",
    "height": "5.26667rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden",
    "position": "relative",
    "zIndex": 1
  },
  "rank-poi-item__slider-mask": {
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "width": "100%",
    "height": "2.13333rem",
    "zIndex": 1
  },
  "rank-poi-item__slider-img": {
    "width": "9.36rem",
    "height": "5.26667rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  }
};



  module.exports = _styles;
  